import { INITIAL_ALLOC } from '@/modules/singleAsset/utils/constants';

const DEFAULT_REGIME_SELECTORS = [1, 11, 33, 62, 98, 120];
const DEFAULT_INSURANCE = 11.2;
const DEFAULT_ALLOC_BY_ASSET = {
  1: { ...INITIAL_ALLOC },
  2: { ...INITIAL_ALLOC },
  3: { ...INITIAL_ALLOC },
  4: { ...INITIAL_ALLOC },
  5: { ...INITIAL_ALLOC },
};

const defaultSettings = {
  mode: 'singleAsset',
  fromYear: 1901,
  toYear: 2020,
  yearsList: [
    [2000, 2001],
    [2002, 2008],
  ],
  selectedType: 'normal',
  firstAsset: 'spx',
  firstAssetName: 'SPX',
  // single-asset inputs
  secondAsset: 'gold',
  secondAssetName: 'Gold',
  insuranceSliderValue: DEFAULT_INSURANCE,
  lock: false,
  regimeCount: 4,
  regimeSelectors: [...DEFAULT_REGIME_SELECTORS],
  alloc: { ...INITIAL_ALLOC },
  percentileDropdown: {
    percentile1Dropdown: 50,
    percentile2Dropdown: 5,
  },
  // multi-asset inputs
  assets: [1],
  activeAsset: 1,
  secondAssets: { 1: 'gold' },
  secondAssetNames: { 1: 'Gold' },
  insuranceSliderValues: {
    1: DEFAULT_INSURANCE,
    2: DEFAULT_INSURANCE,
    3: DEFAULT_INSURANCE,
    4: DEFAULT_INSURANCE,
    5: DEFAULT_INSURANCE,
  },
  allocByAsset: { ...DEFAULT_ALLOC_BY_ASSET },
  pin: true,
  allocLock: false,
  percentile1Dropdown: {
    1: 50,
    2: 50,
    3: 50,
    4: 50,
    5: 50,
  },
  percentile2Dropdown: {
    1: 5,
    2: 5,
    3: 5,
    4: 5,
    5: 5,
  },
};

export default defaultSettings;
